module.exports = __webpack_public_path__ + "img/ext-link-arrow-light.ef9c1f82.svg";